import React from 'react';
import { useTranslation } from 'react-i18next';

import { screens, ScreensNameType } from '@navigation';
import {
  NavigationListView,
  NavigationListViewRouteType,
} from '@components';
import { useNavOptionsSet } from '@hooks';
import { synthoURLs } from '@constants';

const ROUTES: NavigationListViewRouteType[] = [
  { url: synthoURLs.FAQ, tKey: 'help.faq' },
  { screen: screens.ContactUs, tKey: 'help.contactUs' },
];

const BREADCRUMB_ROUTES: ScreensNameType[] = [
  screens.Profile,
  screens.Settings,
  screens.Help,
];

export function HelpScreen() {
  const { t } = useTranslation();

  useNavOptionsSet({ title: t('help.title') });

  return (
    <NavigationListView
      title={t('help.title')}
      routes={ROUTES}
      breadcrumbRoutes={BREADCRUMB_ROUTES}
    />
  );
}
